module.exports = __webpack_public_path__ + "static/media/Oct_2025_4.f5921930.webp";